<template>
  <!-- dialog confirm request order / teruskan pesanan -->
  <v-dialog
    v-model="dialogAnnouncement"
    persistent
    scrollable
    max-width="55%"
    style="overflow: hidden!important;"
  >
    <v-card>
      <v-card-title class="text-h6 text-h6 text-capitalize dark--text">
        <span>Pengumuman</span>
      </v-card-title>

      <v-card-text class="mt-3 text-center" style="min-height: 400px;">
        <v-row>
          <v-col cols="12" md="12" class="pa-0" v-if="!loading">
            <v-carousel v-model="slides" height="auto">
              <v-carousel-item
                v-for="(item, idx) in announcement"
                :key="idx"
              >
                <v-sheet
                  max-height="100vh"
                  tile
                >
                  <div class="announce-content">
                    <v-img :src="item.content_image" width="auto" height="100%" min-height="400px" cover ></v-img>
                    <div class="d-content d-block mt-2" v-html="item.content_body"></div>
                  </div>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </v-col>

          <v-col cols="12" md="12" class="pa-0" v-else>
            <v-skeleton-loader
              v-bind="attrs"
              type="image"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="">
        <v-spacer></v-spacer>
        <v-row class="text-center">
          <v-btn
            outlined
            class="my-4 px-5 text-capitalize"
            :loading="loadingStatus"
            @click="dialogAnnouncement = false"
          >
            Tutup
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
      loading: false,
      loadingStatus: false,
      dialogAnnouncement: false,
      slides: 0,
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2,
      }
    }
  },
  computed: {
    ...mapState('dashboard', ['announcement']),
  },
  methods: {
    ...mapActions('dashboard', ['getAnnouncements']),
    
    modalShow() {
			this.dialogAnnouncement = true
		},
    modalHide() {
			this.dialogAnnouncement = false
		},
    prosesForwardPesananAct(item) {
      this.$emit('action', item)
    },
  },
  async mounted() {
    this.loading = await true
    await this.getAnnouncements()
    if (this.announcement.length > 0) await this.modalShow()

    setTimeout(() => {
      this.loading = false
    }, 1000);
  },
}
</script>

<style lang="scss" scoped>
  .announce-content {
    position: relative;
    overflow: hidden;
  }
  .announce-content .d-content {
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    padding: 2rem 3rem 60px;
    background: rgba(0,0,0,0.05);
    backdrop-filter: blur(50px);
    font-weight: 550;
    color: #111;
    display: block!important;
    font-size: 16px!important;
  }
  .announce-content .d-content p {
    margin-bottom: 0!important;
  }

  .announce-content:hover .d-content {
    background: rgba(0,0,0,0.75);
    backdrop-filter: blur(50px);
    color: #fff;
  }
</style>